import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { sendHoverSoundCommand, sendTabClickSoundCommand } from 'react-wot-bootstrap'

import Flag from '../../../../components/Flag/Flag'

import styles from './Language.scss'

const Language = ({ code, title, isChecked, onClick }) => {
    const handleClick = () => {
        sendTabClickSoundCommand()
        onClick(code)
    }

    return (
        <div
            className={cx(styles.base, isChecked && styles.base__checked)}
            onClick={handleClick}
            onMouseEnter={sendHoverSoundCommand}
        >
            <Flag code={code} />
            <div className={styles.title}>{title}</div>
        </div>
    )
}

Language.propTypes = {
    code: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isChecked: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
}

export default Language



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/Filters/components/Language/Language.jsx